import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Modal } from "antd";

import Load from "../load";

function InformationModal({
  title,
  visible,
  loading,
  onClose,
  children,
  setResult,
  setVisible,
  setLoading,
  loadingMessage,
}) {
  const intl = useIntl();
  const handleClose = useCallback(() => {
    onClose && onClose();
    setLoading && setLoading(false);
    setVisible(false);
    setResult && setTimeout(() => setResult(), 1000);
  }, [onClose, setResult, setVisible, setLoading]);

  return (
    <Modal
      width={500}
      title={title}
      zIndex={9999999}
      okText={intl.formatMessage({
        id: "messages.close",
        defaultMessage: "Zavřít",
      })}
      visible={visible}
      onOk={handleClose}
      onCancel={handleClose}
      confirmLoading={loading}
      cancelButtonProps={{ className: "display-none" }}
    >
      {loading ? <Load message={loadingMessage} /> : children}
    </Modal>
  );
}

export default InformationModal;
